/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileGeoPosition } from './StoreProfileGeoPosition';
import {
    StoreProfileGeoPositionFromJSON,
    StoreProfileGeoPositionFromJSONTyped,
    StoreProfileGeoPositionToJSON,
    StoreProfileGeoPositionToJSONTyped,
} from './StoreProfileGeoPosition';

/**
 * 
 * @export
 * @interface StoreProfileAddress
 */
export interface StoreProfileAddress {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    additional: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    countryCode: string;
    /**
     * 
     * @type {StoreProfileGeoPosition}
     * @memberof StoreProfileAddress
     */
    geoPosition?: StoreProfileGeoPosition;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    googlePlaceId: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    streetNumber: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAddress
     */
    zip: string;
}

/**
 * Check if a given object implements the StoreProfileAddress interface.
 */
export function instanceOfStoreProfileAddress(value: object): value is StoreProfileAddress {
    if (!('additional' in value) || value['additional'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('googlePlaceId' in value) || value['googlePlaceId'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('streetNumber' in value) || value['streetNumber'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    return true;
}

export function StoreProfileAddressFromJSON(json: any): StoreProfileAddress {
    return StoreProfileAddressFromJSONTyped(json, false);
}

export function StoreProfileAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'additional': json['additional'],
        'city': json['city'],
        'countryCode': json['countryCode'],
        'geoPosition': json['geoPosition'] == null ? undefined : StoreProfileGeoPositionFromJSON(json['geoPosition']),
        'googlePlaceId': json['googlePlaceId'],
        'street': json['street'],
        'streetNumber': json['streetNumber'],
        'zip': json['zip'],
    };
}

export function StoreProfileAddressToJSON(json: any): StoreProfileAddress {
    return StoreProfileAddressToJSONTyped(json, false);
}

export function StoreProfileAddressToJSONTyped(value?: StoreProfileAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additional': value['additional'],
        'city': value['city'],
        'countryCode': value['countryCode'],
        'geoPosition': StoreProfileGeoPositionToJSON(value['geoPosition']),
        'googlePlaceId': value['googlePlaceId'],
        'street': value['street'],
        'streetNumber': value['streetNumber'],
        'zip': value['zip'],
    };
}

